import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=25a98488&"
import script from "./ProductImage.vue?vue&type=script&lang=ts&"
export * from "./ProductImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports